import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { RestGenericTypedAttachment } from '@shared/interfaces/attachment.interface';
import { FileMimeType } from '@shared/interfaces/file-mime-types';
import { FileMimeTypePipe } from '@shared/pipes/file-mime-type.pipe';

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PictureComponent extends ComponentAbstract implements OnInit {
  currentComment = '';
  comment: UntypedFormControl = new UntypedFormControl(null, [Validators.maxLength(256)]);
  editMode = false;

  @Input() picture: RestGenericTypedAttachment;
  @Input() file: File;
  @Input() active: boolean;
  @Input() showDeleteButton = false;
  @Input() lockDeleteButton = false;
  @Input() showCommentSection = false;
  @Input() lockCommentActionButtons = false;
  @Input() showCommentActionButtons = false;

  @Output() selectPictureEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() deletePictureEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() updatePictureEvent: EventEmitter<RestGenericTypedAttachment> =
    new EventEmitter<RestGenericTypedAttachment>();

  protected readonly FileMimeType = FileMimeType;

  constructor(protected cdr: ChangeDetectorRef, private fileMimeType: FileMimeTypePipe) {
    super(cdr);
  }

  ngOnInit(): void {
    this.comment.setValue(this.picture?.description || null);
  }

  selectPicture() {
    this.selectPictureEvent.emit();
  }

  deleteItem() {
    this.deletePictureEvent.emit();
  }

  toggleEditMode(editMode: boolean) {
    if (this.showCommentActionButtons) {
      this.editMode = editMode;
      if (this.editMode) {
        this.currentComment = this.comment.value;
      }

      this.cdr.detectChanges();
    }
  }

  save() {
    const attachment: RestGenericTypedAttachment = {
      ...this.picture,
      description: this.comment.value,
    };

    this.updatePictureEvent.emit(attachment);
    this.toggleEditMode(false);
  }

  cancel() {
    this.comment.setValue(this.currentComment);
    this.currentComment = '';
    this.toggleEditMode(false);
  }
}
